import { combineReducers } from 'redux';
import * as auth from '../../../modules/auth';
import createCampaignSlice from '../slices/campaigns/create-campaign-slice';
import createTemplate from '../slices/template/template-slice';

export const rootReducer = combineReducers({
  auth: auth.reducer,
  campaigns : createCampaignSlice,
  template: createTemplate
});

export type RootState = ReturnType<typeof rootReducer>;
